module.exports = window.EM.___fcRuntime.vendors.React16